export default {
    message: {
        hello: 'Hello World',
        welcome: 'Welcome to our app'
    },
    menu: {
        home: 'Home',
        about: 'About',
        contact: 'Contact'
    },
    button: {
        confirm: 'Confirm',
        cancel: 'Cancel'
    }
}